/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A12Inputs */

const et_faq_a12 = /** @type {(inputs: Faq_A12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webflow võimaldab ehitada kiireid, visuaalselt tugevaid ja lihtsasti hallatavaid veebilehti ilma liigsete pluginate ja tehnilise segaduseta. See sobib hästi ettevõtetele, kes tahavad modernset veebilehte, head laadimiskiirust ja lihtsat ühendust CRM-i või muude müügitööriistadega. ScalingWebs kasutab Webflow'd selleks, et luua kodulehti, mis on kiired, turvalised, SEO-sõbralikud ja konversioonile optimeeritud. Vähem tehnilist müra tähendab rohkem fookust sellele, mis loeb: päringud ja müük.`)
};

const en_faq_a12 = /** @type {(inputs: Faq_A12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webflow makes it possible to build fast, visually strong, and easy-to-manage websites without excessive plugins or technical clutter. It's a great fit for companies that want a modern site, good performance, and simple integrations with CRM and sales tools. ScalingWebs uses Webflow to build websites that are fast, secure, SEO-friendly, and conversion-optimized. Less technical noise means more focus on what matters: inquiries and sales.`)
};

/**
* | output |
* | --- |
* | "Webflow makes it possible to build fast, visually strong, and easy-to-manage websites without excessive plugins or technical clutter. It's a great fit for co..." |
*
* @param {Faq_A12Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a12 = /** @type {((inputs?: Faq_A12Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A12Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a12(inputs)
	return en_faq_a12(inputs)
});